<template>
  <div class="fertilizer">
    <div class="box">
      <a href="http://www.google.com/search?q=Document+sans+titre">Document sans titre</a>
    </div>
    <div class="updated">20 VI 2005</div>
  </div>
</template>

<script>
export default {
  name: "sans"
};
</script>

<style scoped>
.fertilizer {
  background-color: #fff;
}

.box {
  font-size: 12pt;
  font-weight: bold;
  margin-top: -10px;
}

.box a:link,
.box a:visited,
.box a:hover {
  color: #eee;
}

.updated {
  color: #e0e0e0;
}
</style>


